import { redactPaymentText } from './paymentTelemetryPrivacy';
import { isPostHogEnabled, posthog } from './posthog';

/**
 * The buyer's link token lives in the URL, so the address is redacted before the event is sent
 * rather than relying on the send-boundary rewrite alone.
 */
export function captureRedactedPageView() {
  if (!isPostHogEnabled) return;
  posthog.capture('$pageview', { $current_url: redactPaymentText(window.location.href) });
}
